module.exports = __webpack_public_path__ + "img/08.38c6a18f.jpg";